import React from 'react';
import { reliabilityContent } from '../data/mock';
import { getImageUrl } from '../lib/api';
import { Shield, Clock, Thermometer, Wrench } from 'lucide-react';

const ReliabilitySection = () => {
  const features = [
    { icon: Shield, title: "Augsta kvalitāte", desc: "Pierādīti materiāli" },
    { icon: Clock, title: "24/7 darbība", desc: "Nepārtraukta pieejamība" },
    { icon: Thermometer, title: "Latvijas klimats", desc: "-30°C līdz +40°C" },
    { icon: Wrench, title: "Viegla apkope", desc: "Skaidrs uzturēšanas plāns" }
  ];

  return (
    <section className="py-20 lg:py-32 bg-slate-50" id="reliability">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="space-y-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
              {reliabilityContent.title}
            </h2>
            
            <p className="text-lg text-slate-600 leading-relaxed">
              {reliabilityContent.description}
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-slate-100 hover:border-slate-200 hover:shadow-sm transition-all"
                >
                  <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="font-medium text-slate-900">{feature.title}</h4>
                    <p className="text-sm text-slate-500 mt-1">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] bg-slate-100 rounded-2xl overflow-hidden shadow-xl">
              <img
                src={getImageUrl(reliabilityContent.image)}
                alt={reliabilityContent.altText}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                  e.target.parentElement.innerHTML = '<div class="text-slate-400 text-center p-8"><div class="w-20 h-20 mx-auto mb-4 bg-slate-200 rounded-lg flex items-center justify-center"><svg class="w-10 h-10 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg></div><span class="text-sm">Uzticamības attēls</span></div>';
                }}
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-28 h-28 bg-emerald-500/10 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReliabilitySection;
